import { inject, Injectable, Optional } from '@angular/core';
import { DatasourceTableJobHttpModel, DatasourceTableJobService } from '@y42/datasource';
import { ErrorHandlerService } from '@y42/error-handling';
import { getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { Y42RouterService, Y42Routes } from '@y42/feature/routing';
import { GitQuery } from '@y42/git';
import { AbstractJobCancelationService, JobContextService, JobHttpService, JobTriggerService } from '@y42/job';
import { OrgQuery } from '@y42/org/state';
import { Y42FeatureType } from '@y42/json-schema';
import { SqlModelingTableJobQuery, SqlModelingTableJobStore, SqlModelingTableStore } from '../../state';
import { SqlModelingStoreQuery } from '../../state/datasource/sql-modeling.store-query';

@Injectable({ providedIn: 'root' })
export class SqlModelingTableJobService extends DatasourceTableJobService {
  constructor(
    triggerService: JobTriggerService,
    parentStore: SqlModelingTableStore,
    jobStore: SqlModelingTableJobStore,
    jobQuery: SqlModelingTableJobQuery,
    jobContext: JobContextService,
    gitQuery: GitQuery,
    errorHandlerService: ErrorHandlerService,
    jobHttpService: JobHttpService<DatasourceTableJobHttpModel>,
    orgQuery: OrgQuery,
    @Optional() jobCancelationService?: AbstractJobCancelationService,
  ) {
    super(
      triggerService,
      parentStore,
      jobStore,
      jobQuery,
      jobContext,
      gitQuery,
      errorHandlerService,
      jobHttpService,
      getY42GitPath(Y42GitFolders.SqlModel),
      Y42Routes.SqlModeling,
      inject(Y42RouterService),
      inject(SqlModelingStoreQuery).selectLoading(),
      inject(SqlModelingStoreQuery).selectActiveId(),
      jobCancelationService,
    );
  }

  readonly defaultFeatureGitPath = getY42GitPath(Y42GitFolders.SqlModel);
  readonly featureType = Y42FeatureType.SqlModel;
}
